import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useConnection } from '../online/onlineConnection.ts';
import { ChatPanel, useIssueToasts } from '../screens/online/shared.tsx';
import styles from '../screens/online/Online.module.css';
import { Button, IconButton, Modal } from '../ui/index.ts';
import { EmoteBubbles, EmoteMenu } from './emotes/Emotes.tsx';
import { useGameStore } from './gameStore.ts';

/**
 * What an online heist adds to the screens of the game: the table's chat, a note while the connection
 * mends itself, and what to do when it cannot be mended. The game itself is the same.
 */
export function OnlineLayer() {
  const { t } = useTranslation('online');
  const state = useConnection();
  const navigate = useNavigate();
  const leave = useGameStore((s) => s.leave);
  const [chatOpen, setChatOpen] = useState(false);
  useIssueToasts();

  return (
    <>
      {state.status === 'reconnecting' ? (
        <div className={styles['banner']}>
          <span className={styles['bannerText']} role="status">
            {t('game.reconnecting')}
          </span>
        </div>
      ) : null}
      <EmoteBubbles />
      <EmoteMenu />
      <div className={styles['chatButton']}>
        <IconButton
          icon="chat"
          label={t('chat.open')}
          onClick={() => {
            setChatOpen(true);
          }}
        />
      </div>
      <Modal
        open={chatOpen}
        onClose={() => {
          setChatOpen(false);
        }}
        title={t('chat.title')}
        actions={
          <Button
            variant="ghost"
            onClick={() => {
              setChatOpen(false);
            }}
          >
            {t('chat.close')}
          </Button>
        }
      >
        <ChatPanel />
      </Modal>
      <Modal
        open={state.status === 'closed'}
        onClose={() => undefined}
        title={t('game.lostTitle')}
        actions={
          <Button
            onClick={() => {
              leave();
              void navigate('/online', { replace: true });
            }}
          >
            {t('game.backToOnline')}
          </Button>
        }
      >
        <p>{t('game.lostBody')}</p>
      </Modal>
    </>
  );
}
